import React from 'react'

import { Button, FormattedHTMLMessage } from '@web/walter-ui-kit'
import s from './s.module.css'
import { lang } from './lang'

interface Props {
    onClose?: () => void
}

// eslint-disable-next-line max-lines-per-function
function Approval({ onClose }: Props) {
    return (
        <div className={s.wrap}>
            <FormattedHTMLMessage {...lang.title} className={s.title} />
            <div className={s.content}>
                <FormattedHTMLMessage {...lang.description} className={s.description} />
            </div>
            <div className={s.button}>
                <Button dataPointer="cancel" size="l" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.gotIt} />
                </Button>
            </div>
        </div>
    )
}

export default Approval
